// https://html.spec.whatwg.org/multipage/media.html#ready-states
// eslint-disable-next-line import/prefer-default-export
export const HAVE_METADATA = 1
